module.exports = __webpack_public_path__ + "img/coding.10a3442d.svg";